import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Box from '~/common/components/Box';
import Select from '~/common/components/Selects/Select';
import Text from '~/common/components/Texts/Text';
import useUrl from '~/common/hooks/useUrl';
import { useNavigation } from '~/stores/navigationStore';

import { getAppraisalAuditGutterGroups } from './utils';

const selectId = 'appraisal-audit-gutter-select';

export default function AppraisalAuditGutterSelect() {
  const { allAlerts } = useNavigation();
  const { obfuscatedLoanIdentifier } = useUrl();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const groups = useMemo(
    () => getAppraisalAuditGutterGroups(allAlerts),
    [allAlerts],
  );

  if (groups.length === 0) {
    return null;
  }

  const pageEnum = pathname.slice(pathname.lastIndexOf('/') + 1);
  const currentPage = `${pageEnum}?${new URLSearchParams(search).toString()}`;
  const selectedPage =
    groups
      .flatMap((group) => group.options)
      .find((option) => option.value === currentPage)?.value ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { obfuscatedLenderDatabaseId, obfuscatedLoanRecordId } =
      obfuscatedLoanIdentifier;
    navigate(
      `/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/audit-history/${event.target.value}`,
    );
  };

  return (
    <Box mb={4} maxWidth="24rem">
      <Text as="label" htmlFor={selectId} display="block" mb={1}>
        Appraisal Section
      </Text>
      <Select id={selectId} value={selectedPage} onChange={handleChange}>
        <option value="" disabled>
          Select a gutter
        </option>
        {groups.map((group) => (
          <optgroup key={group.options[0].value} label={group.label}>
            {group.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </Select>
    </Box>
  );
}
